import React, {  memo, useEffect, useState } from 'react';
import { toPrice } from '@/utils/price';
import DfPrice from '@/components/dFPrice';
import {TLang, ReplaceText, getCookie} from '@/utils/lang';
import { getMovieSessionInfoStr, distanceNow } from '@/utils/time';
import useInterval from '@/hooks/useInterval';
import styles from './index.less';
import fd from '@/assets/imgs/fudou.png';
import { Modal } from 'antd-mobile';
// 根据 java 提供order status
/**
3：待支付、4：已支付、5：出票中、6：出票成功、7：出票失败、
8：已取消（用户手动取消）、11：已取消（支付超时）、9：申请退款、10：退款成功、12：退款失败、13供应商退款、14：部分退款
 */
const getStatus = (s, vendorRefundStatus) => {
  if (vendorRefundStatus) {
    switch(vendorRefundStatus) {
      case 5:
        return '退票中';
      case 6:
        return '退票成功';
      case 7:
        return '退票失败';
    }
  }
  switch (s) {
    case 3:
      return '待支付';
    case 4:
      return '已支付';
    case 5:
      return '出票中';
    case 6:
      return '出票成功';
    case 7:
      return '已取消'; // (出票失败)
    case 8:
      return '已取消'; // (用户手动取消)
    case 9:
      return '申请退款';
    case 10:
      return '退款成功';
    case 11:
      return '已取消'; // 支付超时
    case 12:
      return '退款失败'; //(支付超时)
    case 13:
      return '退款中';
    case 14:
      return '已取消'; //(部分退款)
    default:
      return '';
  }
};
const getStyleColor = (s) => {
  let color;
  /**
3：待支付、4：已支付、5：出票中、6：出票成功、7：出票失败、
8：已取消（用户手动取消）、11：已取消（支付超时）、9：申请退款、10：退款成功、12：退款失败 13供应商退款中
 */
  switch (s) {
    case 3:
      color = '#F44545';
      break;
    case 4:
    case 6:
    case 10:
      color = '#333333';
      break;
    case 5:
    case 9:
      color = window?.dffl_global?.allCommonTheme?.globalThemeColor || '#3FA6FF';
      break;
    case 7:
    case 8:
    case 11:
    case 12:
      color = '#999999';
      break;
    default:
      color = '#333333';
  }
  return color;
};

const OrderItem = (props) => {
  const { data } = props;
  // console.log(data);
  const cancelHandle = (e) => {
    e.stopPropagation();
    e.nativeEvent.stopImmediatePropagation();
    props.cancelOrder && props.cancelOrder(data);
  };
  const payHandle = (e) => {
    setShowTips(false);
    e.stopPropagation();
    e.nativeEvent.stopImmediatePropagation();
    props.payOrder && props.payOrder(data);
  };
  const [countdownText, setCountdownText] = useState('');
  const [countdownTextStatus, setCountdownTextStatus] = useState(data.status);

  const [showTips, setShowTips] = useState(false);
  const [tipsTitle, setTipsTitle] = useState('');
  const [tipsContent, setTipsContent] = useState('');

  data.status === 3 &&
    distanceNow(data.endPayTime) &&
    useInterval(() => {
      let t = distanceNow(data.endPayTime);

      setCountdownText(t);
      if (!t) {
        setCountdownTextStatus(11);
        // props.cancelOrder&&props.cancelOrder(data,true)
      }
    }, 1000);

  const tipsMsg = (e) => {
    e.stopPropagation();
    e.nativeEvent.stopImmediatePropagation();
    if (!data?.showDateTime) {
      return '';
    }
    // 结束时间
    const lastTime =  data?.showDateTime.replace(/-/g, '/').replace(/T/, ' ');
    const lastDate = new Date(lastTime);
    const nowDate = new Date();
    const dateDiff = lastDate.getTime() - nowDate.getTime();//时间差的毫秒数
    const minutes = Math.floor(dateDiff / (60 * 1000));//计算相差分钟数
    if (minutes <= 15) {
      let str;
      if (minutes > 0) {
        setTipsTitle('临近开场提醒');
        // {ReplaceText("X",discount,TLang("X折",'home',false,false,null),false)}
        str = <div className={styles.tipsmsg}>
          {TLang('临近开场提醒：您选购的场次将在', 'home', false, false, null)}
          <span>
            {ReplaceText('X', minutes, TLang('X分钟内', 'home', false, false, null), false)}
          </span>
          {TLang('开场，临近开场场次出票时间较长且出票失败率高，建议选购下个场次', 'home', false, false, null)}
        </div>;
      } else {
        setTipsTitle('已开场提醒');
        str = <div className={styles.tipsmsg}>
          {TLang('已开场提醒：您选购的场次', 'home', false, false, null)}
          <span>{TLang('已开场', 'home', false, false, null)}</span>，
          {TLang('继续购票可能出票时间较长且出票失败率高，建议选购下个场次', 'home', false, false, null)}
        </div>;
      }
      setShowTips(true);
      setTipsContent(str);
    } else {
      setShowTips(false);
      setTipsContent('');
      payHandle(e);
    }
  };
  return (
    <div
      className={styles.orderItemContainer}
      onClick={() => {
        props.click && props.click(data);
      }}
    >
      <div className={styles.orderNumWrapper} style={{marginTop:'16px', marginBottom:'12px'}}>
        <span style={{marginTop:'12px', lineHeight:'20px'}}>{TLang('订单号', 'home', false, false, null)}： {getCookie('df_lang')==='en-US'?<br />:<></>}  {data.orderSn}</span>
        <span
          style={{ color: getStyleColor(countdownTextStatus) }}
        >
          {TLang(getStatus(countdownTextStatus, data.vendorRefundStatus), 'home', false, false, null)}
        </span>
      </div>
      <div className={styles.orderContent}>
        <div className={`${styles.logo} ${data.movieLogo ? '' : 'logo'}`}>
          <img src={data.movieLogo} alt="" className="logo" />
        </div>
        <div className={styles.infoTextWrapper}>
          <p className={styles.movieName}>{data.movieName}</p>
          <div className={styles.movieDesc}>
            <p>{getMovieSessionInfoStr(data)}</p>
            <p>{data.cinemaName}</p>
            <div className={getCookie('df_lang')==='en-US'?styles.otherAlertEn:styles.otherAlert}>
              {/* TODO:是否可以退换的字段由接口提供 */}
              {/* <span>{'不可退换'}</span> */}
              {
                data?.refundDesc && <p>
                  <span
                    style={
                    data?.supportRefund
                    ? { color: window?.dffl_global?.allCommonTheme?.globalThemeColor || '#3FA6FF', borderColor: window?.dffl_global?.allCommonTheme?.globalThemeColor || '#3FA6FF'}
                    : { color: '#FF5757', borderColor: '#FF5757'}
                  }
                    className={
                    getCookie('df_lang')==='en-US'
                    ?styles.otherAlertEn
                    :styles.otherAlert
                  }
                  >{TLang(data?.refundDesc, 'home', false, false, null)}
                  </span>
                  <span
                    style={
                    data?.supportChange
                    ? { color: window?.dffl_global?.allCommonTheme?.globalThemeColor || '#3FA6FF', borderColor: window?.dffl_global?.allCommonTheme?.globalThemeColor || '#3FA6FF'}
                    : { color: '#FF5757', borderColor: '#FF5757'}
                  }
                    className={
                    getCookie('df_lang')==='en-US'
                    ?styles.otherAlertEn
                    :styles.otherAlert
                  }
                  >{TLang(data?.ticketChangeDesc, 'home', false, false, null)}
                  </span>
                </p>
              }
            </div>
          </div>
        </div>
      </div>
      <div className={styles.orderBottom}>
        <div className={styles.priceInfo}>
          <span>
            {ReplaceText('X', data.num, TLang('共X张', 'home', false, false, null), false)}
          </span>
          <span>{TLang('合计', 'home', false, false, null)}: </span>
          <DfPrice
            price={data.totalPrice}
            iconCls="xl"
            textStyles={{ fontSize: '0.3rem', fontWeight: 500, color: '#000' }}
          />
          {/* <img src={fd} alt=""/>
        <span>{toPrice(data.totalPrice)}</span> */}
        </div>
        {data.status === 3 && countdownText ? (
          <div className={styles.needPayWrapper}>
            <span>
              <i />

              {
                ReplaceText('XX', countdownText, TLang('剩余', 'home', false, false, null))
              }

            </span>
            <div onClick={cancelHandle}>{TLang('取消订单', 'home', false, false, null)}</div>
            <div onClick={tipsMsg}>{TLang('立即支付', 'home', false, false, null)}</div>
          </div>
        ) : null}
      </div>
      <Modal
        visible={showTips}
        transparent
        maskClosable
        title={tipsTitle}
        className="confirm-info-modal"
        wrapClassName="conform-wrap"
      >
        <div className="content">
          <div className="desc">
            {tipsContent}
          </div>
          <div className="footer">
            <div className="cancle" onClick={(e) => {
              e.stopPropagation();
              e.nativeEvent.stopImmediatePropagation();
              setShowTips(false);
            }}
            >{TLang('返回', 'home', false, false, null)}</div>
            <div className="confirm" onClick={payHandle}>{TLang('继续支付', 'home', false, false, null)}</div>
          </div>
        </div>
      </Modal>
    </div>
  );
};
// export default OrderItem

export default memo(OrderItem);
